import { ReactNode } from 'react';
import { useUI } from 'hooks/useUI';

interface PaddingWrapProps {
	children: ReactNode;
    short?: boolean;
    extraShort?: boolean;
	sx?: any;
}

function PaddingWrap({ children, short, extraShort, sx }: PaddingWrapProps) {
	const { isSizeOrLess } = useUI();

	const isXSApp = isSizeOrLess('xs');

	let paddingHorizontal = 40;
	let paddingVertical = 40;

	let divideBy = 1;

	if (short) {
		divideBy = 2;
	}

	if (extraShort) {
		divideBy = 4;
	}

	if (isXSApp) {
		divideBy *= 2;
	}

	paddingHorizontal /= divideBy;
	paddingVertical /= divideBy;

	return (
		<div style={{ padding: `${paddingVertical}px ${paddingHorizontal}px `, ...sx }}>
			{children}
		</div>
	);
}

export default PaddingWrap;